import React from "react";

const advantages = [
  "Faster store performance",
  "Higher scalability during peak traffic",
  "Advanced checkout customization",
  "B2B ecommerce capabilities",
  "Multi-store management",
  "International selling tools",
  "Shopify Flow automation",
  "Better API limits for integrations",
  "Strong security and platform reliability",
];

export default function Section8() {
  return (
    <div className="w-full Section8 py-[30px] px-5 md:px-0 bg-[#F9F9F9]">
      <div className="w-[92%] md:w-[85%] mx-auto flex flex-col md:flex-row items-center gap-y-8 md:gap-x-[5%]">
        <div className="w-full md:w-[42%] order-2 md:order-1">
          <img
            src="/assets/Why Choose Shopify Plus for Your Business.webp"
            alt="Why Choose Shopify Plus for Your Business"
            className="w-full h-auto"
          />
        </div>

        <div className="w-full md:w-[54%] order-1 md:order-2 text-center md:text-left">
          <h2 className="text-[24px] md:text-[34px] leading-[32px] md:leading-[41px] font-bold text-[#151515] my-[0.67em]">
            Why Choose Shopify Plus for Your Business?
          </h2>
          <p className="text-[#373737] leading-[22px] text-sm md:text-base font-open mb-4">
            As ecommerce grows, many businesses reach a point where a standard
            ecommerce platform no longer supports their needs. Managing large
            product catalogs, handling high traffic during sales, or expanding
            into new markets often requires more flexibility and control.
          </p>
          <p className="text-[#373737] leading-[22px] text-sm md:text-base font-open mb-5">
            Shopify Plus is designed for businesses that want to scale without
            increasing operational complexity. It provides advanced tools,
            greater customization options, and enterprise-level features while
            keeping day-to-day store management simple.
          </p>
          <p className="text-[#151515] font-bold text-sm md:text-base font-open mb-4">
            Some of the key advantages of Shopify Plus include:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
            {advantages.map((item) => (
              <div
                key={item}
                className="bg-white border border-[#EDEDED] text-[#373737] text-xs md:text-sm rounded-[6px] px-4 py-3 font-open flex items-start gap-2"
              >
                <span className="text-[#DA2128] text-lg leading-[16px]">•</span>
                {item}
              </div>
            ))}
          </div>

          <p className="text-[#373737] leading-[22px] text-sm md:text-base font-open">
            Whether you operate in retail, wholesale, or both, Shopify Plus
            gives your business the flexibility to grow without rebuilding
            your ecommerce platform every few years.
          </p>
        </div>
      </div>
    </div>
  );
}